import React, { useState } from 'react'
import './Footer.css'

import Measure from 'react-measure'

import WrapperButtonsSlider from '../SliderEstancias/WrapperButtonsSlider'

const Footer = props => {
  const [heightFooter, setHeightFooter] = useState(0)

  const mq = window.matchMedia('(max-width: 823px)')

  let padding = 30

  if (!mq.matches) {
    padding = (heightFooter - 41.6) / 2
  }

  return (
    <Measure
      bounds
      onResize={contentRect => {
        setHeightFooter(contentRect.bounds.height)
      }}
    >
      {({ measureRef }) => (
        <div ref={measureRef} className="footer col-12 grid-noGutter">
          <div
            className="col-9_sm-12"
            style={{ padding: `${padding}px 0 0 0` }}
          >
            <WrapperButtonsSlider />
          </div>

          <div className="footer-logo-container col-3_sm-12 grid-noGutter">
            <div className="col-4 sm-hidden" />
            <a
              className="col-4_sm-6"
              href="https://www.avanzacomunicacion.com/"
            >
              <div
                className="footer-logo footer-logo1"
                style={{ backgroundImage: 'url(logopie1.png)' }}
              />
            </a>
            <a className="col-4_sm-6" href="https://www.grupolar.com/">
              <div
                className="footer-logo footer-logo2"
                style={{ backgroundImage: 'url(logopie2.png)' }}
              />
            </a>
          </div>
        </div>
      )}
    </Measure>
  )
}

export default Footer
